<template>
  <div class='h-dialogContainer subnet'>
    <form id='updateSubnetForm'>
      <div class='row h-row-inputBox'>
        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('Topo.subnetName')}}:</div>
            <input class='e-input' name='name' :placeholder='subnetNamePlaceholder' type='text' v-model='subnetInfo.name'/>
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox-topo'>
          <div class='h-inputLit'>{{this.$t('Topo.subnetDes')}}:</div>
          <ejs-textbox multiline='true' name='description' :placeholder='subnetDescriptionPlaceholder' v-model='subnetInfo.description'></ejs-textbox>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div>

          </div>
        </div>
      </div>
      <div class='h-topo-trunk'>
        <div class='h-topo-trunka'>
          <div class='h-topo-trunk-neList'>
            {{this.$t('MML.currentNode')}}
          </div>
          <div class='h-topo-trunk-searchbox'>
            <div class='h-topo-trunk-search'>
              <ejs-textbox :placeholder='subnetFilterPlaceHolder' v-model='selectNelistString'></ejs-textbox>
            </div>
            <div class='h-topo-trunk-btn'></div>
          </div>
          <div class='h-topo-grida'>
            <ejs-grid ref='gridA' v-bind:dataSource='searchSelectNeList' :actionComplete='getChooseCountA' height=333 :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
              <e-columns>
                <e-column type='checkbox' headerText='id' width='30' textAlign='Center' :disable='disableFlagA'></e-column>
                <e-column field='id' :headerText="$t('Topo.nodeId')" width='45' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='strType' :headerText="$t('Topo.nodeType')" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='name' :headerText="headerTextName" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>

        <div class='h-topo-trunkc'>
          <div class='h-topo-trunk-btnbox' >
            <div class='h-topo-trunkc-btna'>
              <ejs-button cssClass='e-small e-round' iconCss='icon hero-icon hero-icon-add' :title='$t("System.add")'
                :isPrimary='true' iconPosition='center' @click.native.prevent='add2Subnet'>
              </ejs-button>
            </div>
            <div class='h-topo-trunkc-btnb'>
              <ejs-button cssClass='e-small e-round' iconCss='icon hero-icon hero-icon-remove' :title='$t("System.delete")'
                :isPrimary='true' @click.native.prevent='delFromSubnet'>
              </ejs-button>
            </div>
          </div>
        </div>

        <div class='h-topo-trunkb'>
          <div class='h-topo-trunk-neList'>
            {{this.$t('Topo.mountNode')}}
          </div>
          <div class='h-topo-trunk-searchbox'>
            <div class='h-topo-trunk-search'>
              <ejs-textbox :placeholder='subnetFilterPlaceHolder' v-model='trunkNelistString'></ejs-textbox>
            </div>
          </div>
          <div class='h-topo-grida'>
            <ejs-grid ref='gridB' v-bind:dataSource='searchSubnetNelist' :actionComplete='getChooseCountB' height=333 :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
              <e-columns>
                <e-column type='checkbox' headerText='id' width='30' textAlign='Center' :disable='disableFlagB'></e-column>
                <e-column field='id' :headerText="$t('Topo.nodeId')" width='45' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='strType' :headerText="$t('Topo.nodeType')" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='name' :headerText="headerTextName" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </div>
      <div class='h-clear-rowMg'></div>
    </form>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import { createNamespacedHelpers } from 'vuex';
import { EventBus } from '../../plugins/eventBus';

const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');

export default {
  name: 'update-subnet',
  components: {
  },
  data() {
    return {
      disableFlagA: false,
      disableFlagB: false,
      //SearchHoder: this.$t('Topo.nodeName'),
      subnetFilterPlaceHolder: this.$t('Topo.subnetFilterPlaceHolder'),
      headerTextName: this.$t('Topo.nodeName'),
      subnetNamePlaceholder: this.$t('Topo.subnetName'),
      subnetTypePlaceholder: this.$t('Topo.subnetType'),
      subnetDescriptionPlaceholder: this.$t('Topo.subnetDes'),
      subnetInfo: {
        id: '',
        name: '',
        type: 0,
        parentId: '',
        positionX: 0,
        positionY: 0,
        children: {},
        description: '',
      },
      authNetIds: [],
      visionData: [],
      typeFields: { value: 'value', text: 'typeName' },
      selectNelistString: '',
      trunkNelistString: '',
      selectNelist: [],
      trunkNelist: [],
      readSubnet: true,
      successMessage: this.$t('Track.success'),
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = 'left';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          name: {
            required: [true, `${this.$t('Pm.alertRequired')}`],
            regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
            maxLength: [30, `${this.$t('Topo.topoMaxLength')}30`],
          },
          description: {
            maxLength: [255, `${this.$t('Topo.topoMaxLength')}255`],
          },
        }
      },
    };
  },

  mounted() {
    this.bindValidate();
  },
  computed: {
    ...mapGetters(['physicalNodes', 'getPhysicalById', 'getTypeByCode', 'getTopoGraph']),
    // 计算数学，匹配搜索
    searchSelectNeList() {
      let dataList = this.selectNelist;
      let searchString = this.selectNelistString;
      console.log('dataList', dataList);
      if (!searchString) {
        return dataList;
      }
      searchString = searchString.trim().toLowerCase();
      dataList = dataList.filter(item => (
        item.name.trim().toLowerCase().indexOf(searchString) !== -1 || item.strType.trim().toLowerCase().indexOf(searchString) !== -1
      ));
      return dataList;
    },
    searchSubnetNelist() {
      let dataList = this.trunkNelist;
      console.log('updateSubnet-trunkNelist', this.trunkNelist);
      let searchString = this.trunkNelistString;
      if (!searchString) {
        return dataList;
      }
      searchString = searchString.trim().toLowerCase();
      dataList = dataList.filter(item => (
        item.name.trim().toLowerCase().indexOf(searchString) !== -1 || item.strType.trim().toLowerCase().indexOf(searchString) !== -1
      ));
      return dataList;
    },
  },
  watch: {
    selectNelistString() {
      this.disableFlagA = true;
    },
    trunkNelistString() {
      this.disableFlagB = true;
    },
  },
  methods: {
    ...mapActions(['setPhysical', 'setLogical', 'setParentNe', 'addParentNe', 'delParentNe']),
    bindValidate() {
      this.formObj = new FormValidator('#updateSubnetForm', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
    outputs(addSubnet, positionX, positionY) {
      //表单验证
      if(!this.validate()){
        return;
      }
      // if(this.trunkNelist.length === 0) {
      //   EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.emptySubnet')});
      //   return;
      // }

       //-- when has subnet , do not found element number
        var containSubnet = false;
        for(var i = 0 ; i < this.trunkNelist.length ;i++)
        {
        	if( this.trunkNelist[i].type == null || Number(this.trunkNelist[i].type) == 0 )
        	{
        		containSubnet = true;
        		break;
        	}
        }

      // if( containSubnet == false && this.trunkNelist.length < 2) {
      //     EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.SubnetAtLeastTwoNodes')});
      //     return;
      // }

      if(addSubnet) {
        this.subnetInfo.positionX = positionX;
        this.subnetInfo.positionY = positionY;
      }
      const aSubnet = [],
        aTrunk = [],
        aDevice = [],
        aEnvironment = [],
        aDeployEnvironment = [],
        map = new Map();
      for (let i = 0; i < this.trunkNelist.length; i++) {
        const node = this.getPhysicalById(this.trunkNelist[i].id.toString());
        if (node) {
          if (node.type == 0) {
            aSubnet.push(this.trunkNelist[i].id);
          }
          else if (node.type === 20001) {
            aTrunk.push(this.trunkNelist[i].id);
          }
          else if (node.type == 'DP') {
            aEnvironment.push(this.trunkNelist[i].id);
          }
          else if ( Number(node.type) >= 30001 && Number(node.type) <= 30010 ) {
            aDeployEnvironment.push(this.trunkNelist[i].id);
          }
          else {
            aDevice.push(this.trunkNelist[i].id);
          }
        }
      }
      if (aSubnet.length > 0) {
        	map.set('Subnet', aSubnet);
      }
      if (aTrunk.length > 0) {
        	map.set('Cluster', aTrunk);
      }
      if(aDeployEnvironment.length > 0)
      {
      		map.set('DeployEnvironment', aDeployEnvironment);
      }
      if (aDevice.length > 0) {
        	map.set('Equipment', aDevice);
      }
      if (aEnvironment.length > 0) {
        	map.set('Environment', aEnvironment);
      }
      this.subnetInfo.children = this.map2Obj(map);
      const params = { ...this.subnetInfo };
      if (this.subnetInfo.id !== '' && this.subnetInfo.id !== undefined) {
        this.axios.post('/lte/ems/env/topo/subnet/modifySubnet', params).then(response => {


          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            //EventBus.$emit('toast', {type: 'success', content: this.successMessage});
            //this.$emit('updateSubnet', this.subnetInfo);
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      }
      this.closeWindow();
    },
    closeWindow() {
      this.$emit('close');
    },
    async setAuthNetElement(){

    	  let IsAdminRole = false;
		  await this.$axios.get('/lte/ems/auth/findSystemRole').then(response => {
			        if (response && response.status === 200 && response.data !== undefined)
			        	IsAdminRole = response.data;

		  });
	      //-- admin has all Net
	      if (IsAdminRole == true)
	      {
	      		if(this.trunkNelist != null && this.trunkNelist.length > 0)
            	{
            	 	for(var i=0; i< this.trunkNelist.length ;i++)
            			this.authNetIds.push( this.trunkNelist[i].id );
            	}
	      		return ;
	      }

		  //-- common user
		  var serverAuthNetIds = new Array();
	      await this.$axios.get('/lte/ems/auth/findAuthNodeList').then(response => {
	        	if (response && response.status === 200 && response.data && response.data.length > 0) {
		          response.data.forEach(element => {
		            	serverAuthNetIds.push(element.nodeId.toString());
		          });
	        	}
	      });

	      for(var i=0; i< this.trunkNelist.length ;i++)
          {
          		if(this.trunkNelist[i].typeCode =="0")
          		{
          			this.authNetIds.push( this.trunkNelist[i].id );
          			continue;
          		}

          		for( var j =0 ; j< serverAuthNetIds.length; j++)
          		{
          			if(serverAuthNetIds[j] == this.trunkNelist[i].id)
          			{
          				this.authNetIds.push( this.trunkNelist[i].id );
          				break;
          			}
          		}
          }

          var abc = this.authNetIds;
    	  return abc;
    },
    async IsAdmin(){
    	 //-- get netElement auth
         let IsAdminRole = false;
		 await this.$axios.get('/lte/ems/auth/findSystemRole').then(response => {
				        if (response && response.status === 200 && response.data !== undefined)
				        	IsAdminRole = response.data;

		});
    	return IsAdminRole;
    },
    async getAuthNetElement(){
    	  //-- common user
			  var serverAuthNetIds = new Array();
		      await this.$axios.get('/lte/ems/auth/findAuthNodeList').then(response => {
		        	if (response && response.status === 200 && response.data && response.data.length > 0) {
			          response.data.forEach(element => {
			            	serverAuthNetIds.push(element.nodeId.toString());
			          });
		        	}
		      });
		      return  serverAuthNetIds;
    },
    setAllowRemoveNet(IsAdminRole, serverAuthNetIds){

		    if (IsAdminRole == true)
		    {
		      		if(this.trunkNelist != null && this.trunkNelist.length > 0)
	            	{
	            	 	for(var i=0; i< this.trunkNelist.length ;i++)
	            			this.authNetIds.push( this.trunkNelist[i].id );
	            	}
		      		return ;
		    }
		  	else {
		  		//-- common user
			    for(var i=0; i< this.trunkNelist.length ;i++)
		        {
		          		if(this.trunkNelist[i].typeCode =="0")
		          		{
		          			this.authNetIds.push( this.trunkNelist[i].id );
		          			continue;
		          		}

		          		for( var j =0 ; j< serverAuthNetIds.length; j++)
		          		{
		          			if(serverAuthNetIds[j] == this.trunkNelist[i].id)
		          			{
		          				this.authNetIds.push( this.trunkNelist[i].id );
		          				break;
		          			}
		          		}
		        }
		  	}
    },
    initData(isAdd, data, nodes) {

      // 加载同级节点
      if (nodes && nodes.length > 0) {

      		const childrenNode = [];
        	const childrenNodeId = [];
       	 	nodes.forEach(element => {

         		 if ( element.type == 0 || element.type == 'DP'
         		 || (Number(element.type) >= 10004 && Number(element.type) <= 10009)
         		 || (Number(element.type) >= 30001 && Number(element.type) <= 30010)){

			            if (isAdd === 'add') {
			              	childrenNode.push(element);
			            }
			            if (isAdd === 'update' && element.id.toString() !== data.id.toString()) {
			              	childrenNode.push(element);
			              	childrenNodeId.push(element.id);
			            }
          		 }
        	});

      		this.selectNelist = childrenNode;
      }


      if (isAdd === 'add') {
        this.subnetInfo.parentId = data;
      }
      else if (isAdd === 'update') {
        if (data !== null && data !== undefined) {
          this.subnetInfo.id = data.id;
          this.subnetInfo.name = data.name;
          this.subnetInfo.parentId = data.parentId;
          this.subnetInfo.positionX = data.positionX;
          this.subnetInfo.positionY = data.positionY;
          this.subnetInfo.description = data.description;
        }
        // 向后台请求所有下级节点
        const subnet = { ...this.subnetInfo };
        this.axios.post('/lte/ems/env/topo/subnet/findSubnetNe', subnet).then(response => {
	          if (response.data.errorCode !== 'SUCCESS') {
	          		 console.log('查找子网子节点失败:', response.data.errorString);
	          		 return;
	          }
	          if (result !== null && result !== undefined)
	          {
	          		console.log('子节点集合为空');
	          		return;
	          }

        	let childrenList = [];
            const result = response.data.resultVal;

            if (result.environmentList && result.environmentList.length > 0) {
                	result.environmentList.forEach(env => {
                  		env.strType = env.type;
                	});
                	childrenList = childrenList.concat(result.environmentList);
            }

            if (result.equipmentList && result.equipmentList.length > 0) {
                result.equipmentList.forEach(equipment => {
                  equipment.strType = this.getTypeByCode(equipment.typeCode);
                });
                childrenList = childrenList.concat(result.equipmentList);
            }

            if (result.subnetList && result.subnetList.length > 0) {
                result.subnetList.forEach(subnet => {
                  subnet.strType = this.getTypeByCode(0);
                });
                childrenList = childrenList.concat(result.subnetList);
            }

            this.trunkNelist = childrenList;

             //-- admin has all Net
		     //-- get netElement auth
	         let IsAdminRole = false;
			 this.$axios.get('/lte/ems/auth/findSystemRole').then(response => {

			     if (response && response.status === 200 && response.data !== undefined)
			     {
			     	 IsAdminRole = response.data;
			     	 if(IsAdminRole == true)
			     	 {
			     	 	 this.setAllowRemoveNet(IsAdminRole, null);
			     	 	 return;
			     	 }

			     	 var serverAuthNetIds = new Array();
				     this.$axios.get('/lte/ems/auth/findAuthNodeList').then(response => {
				        	if (response && response.status === 200 && response.data && response.data.length > 0) {
					           response.data.forEach(element => {
					            	serverAuthNetIds.push(element.nodeId.toString());
					           });

					           this.setAllowRemoveNet(IsAdminRole, serverAuthNetIds);
				        	}
				      });
			     }
			});

        });
      }
    },
    add2Subnet() {
      const This = this;
      const item = this.$refs.gridA.getSelectedRecords();

      for (let i = 0; i < item.length; i++) {
        This.trunkNelist.push(item[i]);
        const index = This.selectNelist.findIndex(v => v.id === item[i].id);
        This.selectNelist.splice(index, 1, { id: '' });
      }
      This.trunkNelist = This.trunkNelist.filter(() => true);
      This.selectNelist = This.selectNelist.filter(val => !(val.id === ''));
    },
    delFromSubnet() {

    	 const This = this;
	     const item = this.$refs.gridB.getSelectedRecords();

	     const index = 0;
	     for (let i = 0; i < item.length; i++)
	     {
	      		const hasPermis = This.authNetIds.find(v => v === item[i].id);
	      		if(hasPermis == undefined || hasPermis == null)
	      		{
	      			EventBus.$emit('toast', { type: 'warning', content: this.$t('Topo.permissionDenied') });
			    	return;
	      		}
	     }

	     for (let i = 0; i < item.length; i++) {

	        This.selectNelist.push(item[i]);
	        const index = This.trunkNelist.findIndex(v => v.id === item[i].id);
	        This.trunkNelist.splice(index, 1, { id: '' });
	     }
	     This.selectNelist = This.selectNelist.filter(() => true);
	     This.trunkNelist = This.trunkNelist.filter(val => !(val.id === ''));
	     console.log('删除子节点:', item);
    },
    // 将选中节点封装, 每次点击添加或移除按钮都向后台发请求
    dealChildren(item) {
      const aSubnet = [];
      const aEquip = [];
      item.forEach(sub => {
        if (sub.typeCode === 0 || sub.typeCode === 1) {
          aSubnet.push(sub.id);
        } else {
          aEquip.push(sub.id);
        }
      });
      const map = new Map();
      if (aSubnet.length > 0) {
        map.set('Subnet', aSubnet);
      }
      if (aEquip.length > 0) {
        map.set('Equipment', aEquip);
      }
      return this.map2Obj(map);
    },
    // 将Map转对象, 为转JSON准备
    map2Obj(mapStr) {
      const newObj = Object.create(null);
      mapStr.forEach((val, index) => {
        newObj[index] = val;
      });
      return newObj;
    },
    getChooseCountA(){
      this.disableFlagA = this.selectNelist.length === 0 ? true : false;
    },
    getChooseCountB(){
      this.disableFlagB = this.trunkNelist.length === 0 ? true : false;
    }
  }
};
</script>
